/**
 * Per-tenant theme application for Who Am I?.
 *
 * Internal-to-who-am-i copy. CSS-var names are kept identical (--sg-*) so
 * streamers who already tuned their WhatIs / Survey Says theme see the same
 * colors here automatically.
 */
import type { ThemePalette } from '@sg/shared';

/**
 * Default palette. Cyan-leaning accent gives the mystery scene a slight
 * detective-noir vibe while keeping the brand yellow + deep blue.
 */
export const DEFAULT_THEME: ThemePalette = {
  primary: '#FFC43D',
  secondary: '#060CE9',
  accent: '#00F0FF',
  background: '#0A0E27',
  text_on_primary: '#060CE9',
  text_on_secondary: '#FFC43D',
  tile_bg: '#060CE9',
  celebration: '#22C55E',
};

/** Map a ThemePalette key to its CSS custom-property name. `background` is
 * shortened to `--sg-bg` to match the existing convention used by WhatIs and
 * Survey Says (so streamers' tuned palettes carry across games). */
function cssVarFor(key: keyof ThemePalette): string {
  if (key === 'background') return '--sg-bg';
  return `--sg-${key.replace(/_/g, '-')}`;
}

export function applyTheme(theme: ThemePalette): void {
  if (typeof document === 'undefined') return;
  const root = document.documentElement;
  for (const key of Object.keys(theme) as Array<keyof ThemePalette>) {
    root.style.setProperty(cssVarFor(key), theme[key]);
  }
}
